const expiredMillisecond = 48 * 60 * 60 * 1000;

const resourceMaxMillisecond = 10 * 60 * 1000;  /* 资源广场 10分钟 */
const activityMaxMillisecond = 10 * 60 * 1000;  /* 活动广场 10分钟 */
const pluginMaxMillisecond = 5 * 60 * 1000;  /* 插件广场 5分钟 */

const resourceMaxAccessNum = 4; 
const activityMaxAccessNum = 3;
const pluginMaxAccessNum = 4;

export {
  expiredMillisecond,
  resourceMaxMillisecond,
  activityMaxMillisecond,
  pluginMaxMillisecond,
  resourceMaxAccessNum,
  activityMaxAccessNum,
  pluginMaxAccessNum ,
}

/* 资源广场 创建副本 */

export function handleUserBehaviorByType(type) {
  try {
    const key = `MG_SUBS_${type.toUpperCase()}`;
    const subs = JSON.parse(window.localStorage.getItem(key));
    if (!subs) {
      return;
    }
    const nowTime = Date.now();
    if (nowTime - (subs.expired + expiredMillisecond) <= 0) {
      return;
    } 

    const maxMillisecond  = getInfoByType();
    if (nowTime > (subs.createTime + maxMillisecond)) {
      return;
    }    

    subs.isUserBehavior = true; 
    window.localStorage.setItem(key, JSON.stringify(subs)); 
  } catch (error) {
    console.error(error);    
  }
}


function getInfoByType(type) {
  let maxMillisecond = 0;

  switch(type) {
    case 'resource':
      maxMillisecond = resourceMaxMillisecond;
      break;
    case 'activity':
      maxMillisecond = activityMaxMillisecond;
      break;
    case 'plugin':
      maxMillisecond = pluginMaxMillisecond;
      break;
    default:
      maxMillisecond = resourceMaxMillisecond;
      break;
  }

  return maxMillisecond;
}

export function clearRecordNum() {
  ['RESOURCE', 'PLUGIN', 'ACTIVITY'].forEach((str) => {
    const key = `MG_SUBS_${str}`;
    const data = window.localStorage.getItem(key);
    if (!data) return;
    const subs = JSON.parse(data);
    if (!subs) return;
    subs.accessNum = 0; 
    subs.createTime = 0; 
    window.localStorage.setItem(key, JSON.stringify(subs));
  });
}
